var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: _vm.stylePanel },
    [
      _c(
        "CompassPanel",
        {
          ref: _vm.refPanel,
          attrs: {
            size: "large",
            title: _vm.email.subject,
            icon: "obj-slsy-sent-email",
            enableShrink: ""
          },
          on: { toggled: _vm.toggleState, closed: _vm.closePanel },
          scopedSlots: _vm._u(
            [
              _vm.email.status === "failed_to_send"
                ? {
                    key: "footer",
                    fn: function() {
                      return [
                        !_vm.isPanelMinimized
                          ? _c("div", { staticClass: "email-panel__footer" }, [
                              _c(
                                "div",
                                {
                                  staticClass: "compass-panel__footer--default"
                                },
                                [
                                  _c("CompassButton", {
                                    attrs: {
                                      label: _vm.$t.__("common.actions.delete"),
                                      type: "secondary",
                                      disabled: _vm.isLoadingButtonResend
                                    },
                                    on: { click: _vm.handleDelete }
                                  }),
                                  _vm._v(" "),
                                  _c("CompassButton", {
                                    attrs: {
                                      label: _vm.$t.__(
                                        "email.emailPreviewPanel.action_resend"
                                      ),
                                      loading: _vm.isLoadingButtonResend
                                    },
                                    on: { click: _vm.handleResend }
                                  })
                                ],
                                1
                              )
                            ])
                          : _vm._e()
                      ]
                    },
                    proxy: true
                  }
                : null
            ],
            null,
            true
          ),
          model: {
            value: _vm.showPanel,
            callback: function($$v) {
              _vm.showPanel = $$v
            },
            expression: "showPanel"
          }
        },
        [
          _c("template", { slot: "default" }, [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: !_vm.isPanelMinimized,
                    expression: "!isPanelMinimized"
                  }
                ],
                staticClass: "email-panel__content"
              },
              [
                _vm.email.status === "failed_to_send"
                  ? _c("CompassAlert", {
                      attrs: {
                        type: "error",
                        description: _vm.getDescriptionAlert,
                        showClose: false,
                        action: _vm.getActionAlert
                      }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _c("EmailPreviewPanelContent", {
                  attrs: { email: _vm.email, thread: _vm.thread }
                })
              ],
              1
            )
          ])
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }